import { baseApi } from "../baseApi";

const onCallApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOnCallStatus: builder.query({
      query: (queueId) =>
        queueId ? `/api/on-call/status?queueId=${queueId}` : "/api/on-call/status",
      providesTags: [{ type: "OnCallStatus", id: "LIST" }],
    }),

    toggleOnCall: builder.mutation({
      query: (body) => ({ url: "/api/on-call/toggle", method: "POST", body }),
      invalidatesTags: [{ type: "OnCallStatus", id: "LIST" }],
    }),

    getOnCallQueues: builder.query({
      query: () => "/api/on-call/queues",
      providesTags: [{ type: "OnCallQueue", id: "LIST" }],
    }),

    createOnCallQueue: builder.mutation({
      query: (body) => ({ url: "/api/on-call/queues", method: "POST", body }),
      invalidatesTags: [{ type: "OnCallQueue", id: "LIST" }],
    }),

    updateOnCallQueue: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/api/on-call/queues/${id}`, method: "PUT", body }),
      invalidatesTags: [{ type: "OnCallQueue", id: "LIST" }],
    }),

    // Search available US phone numbers by area code
    searchAvailableNumbers: builder.query({
      query: ({ areaCode, city }) => {
        const params = new URLSearchParams({ areaCode });
        if (city?.trim()) params.set("city", city.trim());
        return `/api/on-call/available-numbers?${params.toString()}`;
      },
    }),

    // Provision a phone number for a queue (creates sub-account, buys number, sets webhook)
    provisionOnCallNumber: builder.mutation({
      query: ({ id, phoneNumber }) => ({
        url: `/api/on-call/queues/${id}/provision`,
        method: "POST",
        body: { phoneNumber },
      }),
      invalidatesTags: [{ type: "OnCallQueue", id: "LIST" }],
    }),

    // Release the provisioned number from a queue
    releaseOnCallNumber: builder.mutation({
      query: (id) => ({ url: `/api/on-call/queues/${id}/provision`, method: "DELETE" }),
      invalidatesTags: [{ type: "OnCallQueue", id: "LIST" }],
    }),

    getOnCallVoicemails: builder.query({
      query: ({ queueId, limit = 50, offset = 0 } = {}) => {
        const params = new URLSearchParams({ limit, offset });
        if (queueId) params.set("queueId", queueId);
        return `/api/on-call/voicemails?${params.toString()}`;
      },
      providesTags: [{ type: "OnCallVoicemail", id: "LIST" }],
    }),

    markVoicemailRead: builder.mutation({
      query: (id) => ({ url: `/api/on-call/voicemails/${id}/read`, method: "PATCH" }),
      invalidatesTags: [{ type: "OnCallVoicemail", id: "LIST" }],
    }),
  }),
});

export const useGetOnCallStatusQuery = onCallApi.useGetOnCallStatusQuery;
export const useToggleOnCallMutation = onCallApi.useToggleOnCallMutation;
export const useGetOnCallQueuesQuery = onCallApi.useGetOnCallQueuesQuery;
export const useCreateOnCallQueueMutation = onCallApi.useCreateOnCallQueueMutation;
export const useUpdateOnCallQueueMutation = onCallApi.useUpdateOnCallQueueMutation;
export const useSearchAvailableNumbersQuery = onCallApi.useSearchAvailableNumbersQuery;
export const useProvisionOnCallNumberMutation = onCallApi.useProvisionOnCallNumberMutation;
export const useReleaseOnCallNumberMutation = onCallApi.useReleaseOnCallNumberMutation;
export const useGetOnCallVoicemailsQuery = onCallApi.useGetOnCallVoicemailsQuery;
export const useMarkVoicemailReadMutation = onCallApi.useMarkVoicemailReadMutation;
